// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__1e7pI","pendingPaymentIcon":"CalendarEvent_pendingPaymentIcon__2ycOC","gfeWrapper":"CalendarEvent_gfeWrapper__r2gKH"};